let langs_p = document.querySelector(".lang-switcher").children;
let current_lang = 0;
displayLang(current_lang);
let total_langs = langs_p.length - 1;

document.querySelector(".lang-switcher-btn").onclick = lang_switcher_clicked;


function lang_switcher_clicked() {
    current_lang = (current_lang + 1) % total_langs;
    displayLang(current_lang);
}


function displayLang(current_lang) {
    for (var i = 0; i < langs_p.length; i++) {
        if (i == current_lang) {
            langs_p[i].style.display = "block";
        }else if(langs_p[i].className == "lang-switcher-btn") {
            langs_p[i].style.display = "inline-block";
        }else {
            langs_p[i].style.display = "none";
        }
    }
}